import {Link} from "react-router";

import {URL_ORIGINAL_WEBSITE} from "@/lib/links";
import {MarketingFAQs} from "@/marketingPages/components/marketingfaqs/MarketingFAQs.tsx";

import styles from "./IsItDownFAQs.module.scss";

interface IsItDownFAQsProps {
  serviceName?: string;
}

export const IsItDownFAQs = ({serviceName}: IsItDownFAQsProps) => {
  const items = [
    {
      question: `How can I get notified when ${serviceName || "a specific service or website"} is down or has an outage?`,
      answer: (
        <div>
          Uptime.com Third Party Check will enable you to get alerted immediately when{" "}
          {serviceName || "a specific component"} has an outage!{" "}
          <a href={`${URL_ORIGINAL_WEBSITE}/accounts/register`} className="pulse-color-green-500">
            Sign up today for FREE 14-day trial
          </a>{" "}
          to experience it yourself!
        </div>
      ),
    },
    {
      question: serviceName
        ? `Can I check if services or websites other than ${serviceName} are down right now?`
        : "Can I request a service not currently in your list of services to check if it is down?",
      answer: (
        <div>
          Yes!{" "}
          {serviceName && (
            <>
              <Link to="/status" className="pulse-color-green-500">
                Click here
              </Link>{" "}
              to check the status of hundreds of popular web services.
            </>
          )}{" "}
          We are adding services daily/weekly.{" "}
          <Link to="/contact" className="pulse-color-green-500">
            Click here
          </Link>{" "}
          to request for additional services to monitor, or contact{" "}
          <a href="mailto:support@uptime.com" className="pulse-color-gray-600">
            support@uptime.com
          </a>
          .
        </div>
      ),
    },
    {
      question: `Can I add ${serviceName ? `Checks if ${serviceName} is up or down` : "Third Party Checks"} on my Status Page?`,
      answer: (
        <div>
          Yes! You can add any Third Party Check on your{" "}
          <Link to={`${URL_ORIGINAL_WEBSITE}/status-page`} className="pulse-color-green-500">
            Status Page
          </Link>{" "}
          {serviceName && `including ${serviceName} as well as hundreds of other popular web services `}
          as a component so your customers know exactly when one of your dependencies is down and impacting your
          services.
        </div>
      ),
    },
    {
      question: `How do you get this data ${serviceName ? `on whether ${serviceName} is up?` : "and how reliable is the source?"}`,
      answer: (
        <div>
          Our Third Party Check uses advanced data collection methods to pull status from various sources including
          companies' Status Pages and augments it with social signals and other data from our proprietary check platform
          to give you the most realistic and up to date information and alerts on a service.
        </div>
      ),
    },
  ];
  return (
    <div className={styles.container}>
      <MarketingFAQs items={items} title="Uptime.com FAQs" />
    </div>
  );
};
